import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addtNewGuideList, updatatNewGuideList } from "@/api/dataAll/newGuide";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        ad_channel: "",
        ad_placement: "",
        ex_Val: [],
        expand_parameter: {},
        special_product_id: ""
      },
      rules: {
        game: [{
          required: true,
          message: this.$t('gameNotEmpty'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('platformNotEmpty'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('channelNotEmpty'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pkgNotEmpty'),
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: this.$t('pleaseInputParameterName'),
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: this.$t('pleaseInputParameterValue'),
          trigger: "blur"
        }],
        ex_Val: [{
          required: true,
          message: this.$t('pleaseAddContent'),
          trigger: "blur"
        }]
      },
      adPlacementSingleChoice: true
    };
  },
  created: function created() {},
  methods: {
    removeDomain: function removeDomain(item) {
      var index = this.searchData.ex_Val.indexOf(item);

      if (index !== -1) {
        this.searchData.ex_Val.splice(index, 1);
      }
    },
    addDomain: function addDomain() {
      this.searchData.ex_Val.push({
        name: "",
        value: ""
      });
    },
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ex_Val, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!data) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return _this.getAdvPlarform(data);

              case 4:
                _this.searchData.ad_channel = data.ad_channel;
                _context.next = 7;
                return _this.advChannelchange(data.ad_channel);

              case 7:
                _this.searchData = _this.processingData(_objectSpread(_objectSpread({}, _this.searchData), data));
                ex_Val = JSON.parse(data.expand_parameter);

                for (key in ex_Val) {
                  _this.searchData.ex_Val.push({
                    name: key,
                    value: ex_Val[key]
                  });
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: this.searchData.game,
        platform: "",
        channel: "",
        pkg: "",
        ad_channel: "",
        ad_placement: "",
        ex_Val: [],
        expand_parameter: {},
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id
      };

      if (this.rawData.game_show_type == 1) {
        this.advchannels = [];
      }

      this.advLocation = [];
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vaild) {
        if (vaild) {
          if (_this2.searchData.ex_Val.length > 0) {
            var data = {};

            _this2.searchData.ex_Val.forEach(function (item, i) {
              data[item.name] = item.value;
            });

            _this2.searchData.expand_parameter = JSON.stringify(data);
          }

          var reqFn = _this2.searchData.id ? updatatNewGuideList : addtNewGuideList;
          _this2.searchData.game_id = '';
          reqFn(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(_this2.$t('operationSuccess'));
              _this2.dialogFormVisible = false;

              _this2.$emit("refreshDataList", false);
            }
          });
        }
      });
    }
  }
};